// ==============================|| OVERRIDES - TABLE CONTAINER ||============================== //

export default function TableContainer() {
  return {
    MuiTableContainer: {
      styleOverrides: {
        root: ({ theme }) => ({
          border: `1px solid ${theme.vars.palette.divider}`,
          borderRadius: 4,
          backgroundColor: theme.vars.palette.background.paper,
          overflow: 'hidden',
          boxShadow: 'none',
          '& .MuiTable-root': {
            minWidth: '100%'
          }
        })
      }
    }
  };
}
